import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaTimes,
  FaMagic,
  FaFileExcel,
  FaEdit,
  FaArrowRight,
  FaLayerGroup
} from 'react-icons/fa';

/**
 * Modal de entrada: elegir cómo cargar productos (asistente uno a uno, Excel o formulario clásico).
 */
export default function ProductLoadAssistant({ isOpen, onClose, onOpenImport }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const go = (path) => {
    onClose();
    navigate(path);
  };

  const optionClass =
    'group flex w-full items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4 text-left transition hover:border-e0e3-accent/40 hover:bg-white/[0.08]';

  return (
    <div
      className="fixed inset-0 z-[95] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="product-assistant-title"
    >
      <div className="nexo-modal-shell relative w-full max-w-lg overflow-hidden shadow-elevated">
        <div className="relative overflow-hidden border-b border-white/10 bg-e0e3-accent/15 px-6 pb-6 pt-6">
          <div className="relative flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-e0e3-accent/20 ring-1 ring-e0e3-accent/30">
                <FaLayerGroup className="text-xl text-e0e3-accentSoft" aria-hidden />
              </div>
              <div>
                <h2 id="product-assistant-title" className="text-xl font-bold tracking-tight text-e0e3-foreground">
                  Asistente para cargar productos
                </h2>
                <p className="mt-1 text-sm text-e0e3-muted">
                  Elegí la forma que te resulte más cómoda. Siempre podés cambiar después.
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="shrink-0 rounded-lg p-2 text-e0e3-muted transition hover:bg-white/10 hover:text-e0e3-foreground"
              aria-label="Cerrar"
            >
              <FaTimes className="text-lg" />
            </button>
          </div>
        </div>

        <div className="space-y-3 p-5 sm:p-6">
          <button type="button" onClick={() => go('/productos/nuevo?modo=asistente')} className={optionClass}>
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-e0e3-accent text-black shadow-lg shadow-e0e3-accent/25">
              <FaMagic className="text-lg" aria-hidden />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2 font-semibold text-e0e3-foreground">
                Cargar uno a uno, paso a paso
                <FaArrowRight className="text-xs text-e0e3-accent opacity-0 transition group-hover:translate-x-0.5 group-hover:opacity-100" />
              </span>
              <span className="mt-1 block text-sm leading-snug text-e0e3-muted">
                Ideal para empezar: nombre, precios y detalles en pantallas cortas, sin abrumar.
              </span>
            </span>
          </button>

          <button
            type="button"
            onClick={() => {
              onClose();
              onOpenImport();
            }}
            className={optionClass}
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-e0e3-ok text-black shadow-lg shadow-e0e3-ok/20">
              <FaFileExcel className="text-lg" aria-hidden />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2 font-semibold text-e0e3-foreground">
                Importar desde Excel
                <FaArrowRight className="text-xs text-e0e3-ok opacity-0 transition group-hover:translate-x-0.5 group-hover:opacity-100" />
              </span>
              <span className="mt-1 block text-sm leading-snug text-e0e3-muted">
                Si ya tenés una lista en planilla, el mismo asistente visual que revisa filas y sucursal.
              </span>
            </span>
          </button>

          <button
            type="button"
            onClick={() => go('/productos/nuevo')}
            className="flex w-full items-center justify-center gap-2 rounded-xl border border-white/15 bg-white/[0.04] px-4 py-3 text-sm font-medium text-e0e3-foreground transition hover:bg-white/[0.08]"
          >
            <FaEdit className="text-e0e3-muted" aria-hidden />
            Formulario completo (vista clásica)
          </button>
        </div>
      </div>
    </div>
  );
}
